<template>
    <header class="header">
        <div class="container header-container">
            <div v-if="$route.name == 'home'" class="header-logo"></div>
            <router-link v-else :to="{ name: 'home' }" class="header-logo"></router-link>
            <nav v-if="!isEmpty('user')" class="header-nav">
                <div v-click-outside="{
                    handler: 'hideLanguageSelect',
                }" class="header-language-select">
                    <button @click="isOpen = !isOpen">{{ currentLanguage }}</button>
                    <div class="options" v-show="isOpen">
                        <div class="option" v-for="(lang, index) in languages" :key="index"
                            @click="selectLanguage(lang.code)">
                            {{ lang.label }}
                        </div>
                    </div>
                </div>

                <!-- <div
                    @click="search"
                    class="header-search"
                >
                    <form>
                        <input
                            type="text"
                            class="header-search-input"
                            placeholder="Поиск"
                            readonly
                        >
                    </form>
                </div> -->

                <router-link :to="{ name: 'balance' }" class="header-balance-link">
                    <span class="header-balance-text">
                        {{ $t("header.headerBalance") }}:</span>
                </router-link>
                <div v-click-outside="{
                    handler: 'hideBalance',
                }" class="header-balance">
                    <!-- <div
                        @click="showBalance = !showBalance"
                        class="header-balance-opener"
                        :class="{'header-balance-open': showBalance}"
                    >
                        <span class="header-balance-text">Баланс:</span>
                        <span class="header-balance-value">{{ formatBalance(user.balance) }}</span>
                    </div> -->

                    <!-- <div
            @click="showBalance = !showBalance"
            class="header-balance-opener"
            :class="{ 'header-balance-open': showBalance }"
          >
            <span class="header-balance-text">Баланс:</span>
            <span class="header-balance-value">{{
              formatBalance(user.balance)
            }}</span>
          </div> -->

                    <div @click="$modal.show('balance-in')" class="header-balance-opener"
                        :class="{ 'header-balance-open': showBalance }">
                        <span class="header-balance-value">{{
                            formatBalance(user.balance)
                        }}</span>
                    </div>

                    <!-- <div
            class="header-balance-opener"
            :class="{ 'header-balance-open': showBalance }"
          >
            <router-link :to="{ name: 'balance' }">
              <span class="header-balance-text">Баланс:</span>
            </router-link>

            <span
              class="header-balance-value"
              @click="$modal.show('balance-in')"
            >
              {{ formatBalance(user.balance) }}
            </span>
          </div> -->

                    <!-- <router-link
            class="header-balance-opener"
            :class="{ 'header-balance-open': showBalance }"
          >
            <span class="header-balance-text">Баланс:</span>

            <span class="header-balance-value">{{
              formatBalance(user.balance)
            }}</span>
          </router-link> -->

                    <!-- <div
                        v-if="showBalance"
                        class="header-balance-dropdown"
                    >
                        <ul>
                            <li
                                @click="
                                    $modal.show('balance-in');
                                    showBalance = false
                                "
                                class="header-balance-link"
                            >Пополнить счет</li>
                            <li
                                @click="withdraw"
                                class="header-balance-link"
                            >Вывести средства</li>
                        </ul>
                    </div> -->
                </div>
                <div @click="showRoulette" ref="rouletteButton" class="header-roulette">
                    <div class="header-roulette-text">
                        {{ $t("header.headerRouletteText") }}
                        :
                    </div>
                    <div class="header-roulette-opener" :class="{ animate: showCountdown }"></div>
                    <div v-if="myBets">
                        <div class="header-roulette-timer">
                            {{ timeRemain }}
                        </div>
                    </div>
                </div>
                <div v-click-outside="{
                    handler: 'hideUser',
                }" class="header-user">
                    <div @click="toggleUser" class="header-user-opener">
                        <div class="header-user-name">{{ user.first_name }}</div>
                        <div :style="{
                            'background-image': user.avatar
                                ? 'url(' + user.avatar + ')'
                                : '',
                        }" :class="{ 'no-avatar': !user.avatar }" class="header-user-avatar"></div>
                    </div>
                    <div v-if="showUser" class="header-user-dropdown">
                        <ul>
                            <router-link tag="li" :to="{ name: 'settings' }" class="header-user-link"><a> {{
                                $t("header.headerSettings") }}</a></router-link>
                            <router-link tag="li" :to="{ name: 'profile-edit' }" class="header-user-link"><a>
                                    {{ $t("header.headerEdit") }}
                                </a></router-link>
                            <li @click="logout" class="header-user-link">
                                {{ $t("header.headerLogOut") }}
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
            <nav v-else class="nav-unauth">
                <div v-click-outside="{
                    handler: 'hideLanguageSelect',
                }" class="header-language-select">
                    <button @click="isOpen = !isOpen">{{ currentLanguage }}</button>
                    <div class="options" v-show="isOpen">
                        <div class="option" v-for="(lang, index) in languages" :key="index"
                            @click="selectLanguage(lang.code)">
                            {{ lang.label }}
                        </div>
                    </div>
                </div>
                <span @click="$modal.show('login')" class="link nav-unauth-desktop">
                    {{ $t("header.headerLogIn") }}
                </span>
                <span @click="$modal.show('register')" class="link nav-unauth-desktop">
                    {{ $t("header.headerSignUp") }}
                </span>
            </nav>
        </div>
    </header>
</template>

<script>
import { mapGetters } from "vuex";
import { declineNouns } from "@/mixins/declineNouns";
import { calcRouletteTimer } from "@/mixins/calcRouletteTimer";
import { initAfterLogin } from "@/mixins/initAfterLogin";
import Vue from "vue";

export default {
    name: "Header",
    mixins: [declineNouns, calcRouletteTimer, initAfterLogin],
    props: {
        i18n: Object,
    },
    data() {
        return {
            showCountdown: false,
            showUser: false,
            showBalance: false,
            tempNextPlay: null,
            timeRemain: null,
            interval: null,
            navUnauthOpen: false,
            timingPlayed: false,
            isOpen: false,
            languages: [
                { code: "ru", label: "Русский" },
                { code: "en", label: "English" },
                { code: "tr", label: "Turkish" },
                { code: "es", label: "Spanish" },
                { code: "fr", label: "French" },
            ],
        };
    },
    watch: {
        $route(to, from) {
            this.showUser = false;
            this.navUnauthOpen = false;
        },
    },
    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            isEmpty: "user/isEmpty",
            init: "init/fetchInit",
            initIsEmpty: "init/isEmpty",
            timeDelta: "init/fetchTimeDelta",
            myBets: "init/fetchMyBets",
        }),
        nextPlay() {
            if (this.tempNextPlay) {
                let nextP = this.tempNextPlay * 1000 + this.timeDelta;
                return nextP;
            }
            let nextP = this.init.roulette_next * 1000 + this.timeDelta;
            return nextP;
        },
        currentLanguage() {
            const lang = this.$i18n.locale;
            const current = this.languages.find((l) => l.code === lang);
            return current.label;
        },
    },
    created() {
        this.$store.watch(
            (state, getters) => getters["sockets/message"],
            (msg) => {
                if (msg.event) {
                    switch (msg.event) {
                        case "roulette_is_over":
                            this.showCountdown = false;
                            this.$store.dispatch("init/setMyBets", false);
                            this.tempNextPlay = msg.data.roulette_next;
                            setTimeout(() => {
                                this.timingPlayed = false;
                            }, 20000);
                            break;
                        default:
                            break;
                    }
                }
            }
        );
        this.interval = setInterval(() => {
            if (!this.isEmpty("user")) {
                this.calcRouletteTimer();
            }
        }, 1000);
    },
    methods: {
        selectLanguage(langCode) {
            this.$i18n.locale = langCode;
            this.isOpen = false;
            localStorage.setItem("locale", langCode);
            window.location.reload();
            this.$nextTick(() => {
                Vue.observable(this).$forceUpdate();
            });
        },
        getRoulette() {
            this.$store.dispatch("roulette/get");
        },
        withdraw() {
            let period = +new Date() - this.user.withdrawal_date * 1000;
            let days = period / (1000 * 3600 * 24);
            if (days < 30) {
                this.showWarning(
                    "Вы уже выводили деньги в этом месяце. <br> Следующий вывод доступен через " +
                    Math.ceil(30 - days) +
                    " " +
                    this.declineNouns(Math.ceil(30 - days), ["день", "дня", "дней"]) +
                    "."
                );
            } else if (this.user.balance < 100) {
                this.showWarning(
                    "Ваш баланс меньше минимальной суммы, доступной для вывода (100 зариков)."
                );
            } else {
                this.$modal.show("balance-out");
            }

            this.showBalance = false;
        },
        showWarning(warning) {
            this.$modal.show("dialog", {
                title: "Вывод средств",
                text: warning,
                buttons: [
                    {
                        title: "ОК",
                    },
                ],
                width: 730,
            });
        },
        formatBalance(balance) {
            if (typeof balance == "number") {
                return balance;
            }
            let arr = balance.split(".");
            return arr[1] == "00" ? arr[0] : balance;
        },
        transform(props) {
            Object.entries(props).forEach(([key, value]) => {
                props[key] = value < 10 ? `0${value}` : value;
            });
            return props;
        },
        showRoulette() {
            if (
                document
                    .getElementsByTagName("body")[0]
                    .classList.contains("roulette-wrapper")
            ) {
                this.$modal.hide("roulette");
            } else {
                this.$modal.show("roulette", { nextPlay: this.nextPlay });
            }
        },
        search() {
            this.$router.push({ name: "search" });
        },
        hideBalance() {
            this.showBalance = false;
        },
        toggleUser() {
            this.showUser = !this.showUser;
        },
        hideUser() {
            this.showUser = false;
        },
        logout() {
            const vm = new Vue();
            this.$store.dispatch("user/logout").then(() => {
                this.showUser = false;
                this.initAfterLogin();
                this.$router.push({ name: "home" });
                vm.$disconnect();
            });
        },
        hideNavUnauth() {
            this.navUnauthOpen = false;
        },
        hideLanguageSelect() {
            this.isOpen = false;
        },
    },
};
</script>

<style scoped lang="scss">
@import "~@/assets/styles/layout/_header";
</style>
